import React from 'react'

import AIVerified from "../../badge/AIVerified";

import Refund from "./Refund";
import Template from "./Template";
import ArrivalNotification from "./ArrivalNotification";
import DepartureNotification from "./DepartureNotification";

import Submission from "../../modal/Submission";
import Attachments from "../../modal/Attachments";
import DeleteSubmission from "../../modal/DeleteSubmission";

import Notify from "../../../../utils/Notify";
import Backend from "../../../../utils/Backend";
import Confirmation from "../../modal/Confirmation";

export default class DeclarationActions extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      submission: props.submission
    }
  }

  _generate(type, submission){
    Backend.generate(type, submission)
    .then(() => {
      this.setState({
        showPDFGeneratingModal: true
      })
      setTimeout(() => this._checkPDFGenerated(submission), 3000);
    })
    .catch(error => {
      Notify.error(error.message)
      this.setState({
        showPDFGeneratingModal: true
      })
    })
  }

  _checkPDFGenerated(submission){
    if(!this.state.showPDFGeneratingModal){
      return
    }

    Backend.getSubmission(submission.id)
    .then(submission => {
      if(submission.receipt){
        window.open(submission.receipt.url)
        this.setState({showPDFGeneratingModal: false})
        Notify.success("PDF Downloaded")
        return
      }

      setTimeout(() => this._checkPDFGenerated(submission), 1000)
    })
  }

  _handleDelete(submission, reason){
    this.setState({ isDeletingDeclaration: true })
    Backend.deleteSubmission(submission.id, reason)
    .then(() => {
      let label = "Deleted"
      if(submission.status !== "draft"){
        label = "Invalidated"
      }
      Notify.success(`Declaration ${label}`)
      this.setState({
        isDeletingDeclaration: false,
        showDeleteSubmissionModal: false,
      })
      this.props.refresh()
    })
    .catch(e => {
      Notify.error(e.message)
      this.setState({ isDeletingDeclaration: false })
    })
  }

  render(){
    let {
      submission,
      isDeletingDeclaration,
      showAttachmentsModal,
      showPDFGeneratingModal,
      showDeleteSubmissionModal,
      showSubmissionSummaryModal
    } = this.state

    let deletableStatuses = [
      "draft",
      "exported",
      "released",
      "accepted",
      "registered",
      "under_review",
      "insufficient_funds",
      "released_for_export",
    ]

    let showInvalidate = deletableStatuses.indexOf(submission.status) > -1

    let deleteLabel = "Delete"
    if(submission.status !== "draft"){
      deleteLabel = "Invalidate"
    }

    const status = submission.status
    const formType = submission.form.type
    const formSubType = submission.form.subtype
    const amendableFormType = formType === "ais" || formType === "aes" || formType === "cds" || formType === "ics2"

    let amendable = submission.mrn && amendableFormType && submission.amendment_status !== "processing"
    let vatSummary = submission.mrn && (formType === "ais" || formType === "cds")

    const isAES = formType === "aes"
    const isCDS = formType === "cds"
    const isB1 = formSubType === "B1"
    const isH1OrB1 = ["B1", "H1"].indexOf(formSubType) > -1

    let canShowArrivalNotification = submission.mrn && ((isCDS && isH1OrB1) || isAES)
    let canShowDepartureNotification = submission.mrn && ((isCDS && isB1) || isAES)

    return (
      <>
        <div className="submission-actions">
          <div className='row'>
            <div className='col-6 sa-left'>
              { submission.mrn && ["ais", "aes"].indexOf(submission.form.type) > -1 &&
                <>
                  <button
                    onClick={() => {
                      if(submission.clearance_slip){
                        window.open(submission.clearance_slip.url)
                      }else{
                        this._generate("clearance-slip", submission)
                      }
                    }}
                    className="btn btn-sm btn-outline-primary btn-submission-action"
                  >
                    Clearance Slip
                  </button>
                </>
              }
              {
                submission.mrn && ["ais", "aes", "cds", "nhd", "ics2"].indexOf(submission.form.type) > -1 &&
                <>
                  <button
                    onClick={() => {
                      if(submission.receipt){
                        window.open(submission.receipt.url)
                      }else{
                        this._generate("receipt", submission)
                      }
                    }}
                    className="btn btn-sm btn-outline-primary btn-submission-action"
                  >
                    PDF
                  </button>
                </>
              }
              {
                vatSummary &&
                <button
                  className="btn btn-sm btn-outline-primary btn-submission-action"
                  onClick={(e) => this.setState({showSubmissionSummaryModal: true})}
                >
                  Total Duty Calculator
                </button>
              }
              { !submission.template &&
                <button
                  className="btn btn-sm btn-outline-primary btn-submission-action position-relative"
                  onClick={() => this.setState({showAttachmentsModal: true})}
                >
                  Attachments
                  { (submission.form.type === "ais" && submission.form.subtype === "H1") &&
                    <AIVerified/>
                  }
                </button>
              }
            </div>
            <div className='col-6 sa-right'>
              <Template
                type="button"
                submission={submission}
              />

              <Refund
                type="button"
                submission={submission}
                onRefundApplicationSent={() => {
                  this.props.refresh()
                }}
              />

              { canShowArrivalNotification &&
                <ArrivalNotification
                  submission={submission}
                  onArrived={() => {
                    this.props.refresh()
                  }}
                />
              }

              { canShowDepartureNotification &&
                <DepartureNotification
                  submission={submission}
                  onDeparted={() => {
                    this.props.refresh()
                  }}
                />
              }

              { amendable &&
                <button
                  className="btn btn-sm btn-outline-primary btn-submission-action"
                  onClick={() => this.props.goTo(submission)}
                >
                  Amend
                </button>
              }
              {
                showInvalidate &&
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => {
                    this.setState({
                      selectedSubmission: submission,
                      showDeleteSubmissionModal: true
                    })
                  }}
                >
                  { deleteLabel }
                </button>
              }
            </div>
          </div>
        </div>

        {
          showSubmissionSummaryModal &&
          <Submission
            show={showSubmissionSummaryModal}
            submission={submission}
            onHide={() => this.setState({showSubmissionSummaryModal: false})}
          />
        }

        {
          showAttachmentsModal &&
          <Attachments
            show={showAttachmentsModal}
            submission={submission}
            onHide={() => this.setState({showAttachmentsModal: false})}
          />
        }

        {
          showDeleteSubmissionModal &&
          <DeleteSubmission
            show={showDeleteSubmissionModal}
            loading={isDeletingDeclaration}
            submission={submission}
            onConfirm={reason => this._handleDelete(submission, reason)}
            onHide={() => this.setState({showDeleteSubmissionModal: false})}
          />
        }

        {
          showPDFGeneratingModal &&
          <Confirmation
            show={showPDFGeneratingModal}
            title={"Generating PDF..."}
            message={"You will receive an email once the PDF has generated. You can also keep this modal open to view the PDF once its generated."}
            confirmTitleText={"Close, I'll wait for Email"}
            showHide={false}
            onConfirm={() => {
              this.setState({showPDFGeneratingModal: false})
              Notify.success("You will receive the PDF shortly via email.")
            }}
          />
        }
      </>
    )
  }
}

DeclarationActions.defaultProps = {

}
